import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { useHistory } from "react-router-dom";
import Spinner from "../../../../components/Spinner";
import { toastError, toastSuccess } from "../../../../components/Toast";
import useAuthData from "../../../../hook/useAppData";
import { IconLeftArrowVersion2 } from "../../../../icons";
import { getClientById, getProjectByClient, putClient } from "../../service";
import { IFieldValues } from "../form/model";
import LeftScreen from "./components/LeftScreen";
import RightScreen from "./components/RightScreen";
import "./index.scss";

export interface ICLientDetails {
  name: string | null;
  email: string;
  hoursWorkedWeek: string | null;
  img: string | null;
  isDeleted: boolean | null;
  collaborators: number;
  phone: string;
  totalActivedProjects: number;
  totalCanceledProjects: number;
  totalCompletedProjects: number;
  totalProjects: number;
}

interface IProjectDetails {
  collaborators: number;
  endDate: string | null;
  hoursWorkedWeek: string;
  id: number;
  img: string | null;
  name: string;
  status: "Ativo" | "Cancelado" | "Concluído";
}

export default function ListProjectByClient({ match }) {
  const { token } = useAuthData();
  const [client, setClient] = useState<ICLientDetails>();
  const [projects, setProjects] = useState<IProjectDetails[]>();
  const [needSpinner, setNeedSpinner] = useState(true);
  const params = match.params.id;
  const history = useHistory();

  useEffect(() => {
    projectByClient();
  }, []);

  async function projectByClient() {
    const res = await getProjectByClient(token, params);
    setClient(res?.client);
    setProjects(res?.projectsByClient);
    setNeedSpinner(false);
  }

  async function handleStateClientClick() {
    const res = await getClientById(token, params);
    const data: IFieldValues = {
      ...res,
      isDeleted: !res.isDeleted,
    };
    putActionStateOfClient(data);
  }

  async function putActionStateOfClient(data) {
    const responseUpdate = await putClient(token, { body: data }, params);
    if (!responseUpdate?.ok) return toastError("Não foi possível inativar o cliente");
    toastSuccess(data?.isDeleted ? "Cliente inativado com sucesso!" : "Cliente Ativado com Sucesso");
    return setTimeout(() => {
      projectByClient();
    }, 2 * 1000);
  }

  function handleClickNewProject() {
    return history.push(`/projects/form/clients/${params}`);
  }

  function handleUpdateClient() {
    return history.push(`/clients/form/${params}`);
  }

  function handleClickProject(id) {
    return history.push(`/projects/details/${id}`);
  }

  function handleClickExit() {
    return history.push(`/clients`);
  }

  return (
    <>
      <Toaster />
      <Spinner status={needSpinner}>
        <div className="box-header details-client">
          <div className="">
            <h1 className="text-2rem font-familyPoppins text-textPrimary font-semibold flex">
              <span onClick={handleClickExit} className="arrow-exit-client-project cursor-pointer center m-1">
                {IconLeftArrowVersion2}
              </span>{" "}
              <span>Cliente - {client?.name}</span>
            </h1>
          </div>

          <div className="flex flex-row w-full pt-8 gap-1">
            <LeftScreen
              client={client}
              handleClickNewProject={handleClickNewProject}
              handleUpdateClient={handleUpdateClient}
              handleStateClientClick={handleStateClientClick}
            />
            <RightScreen projects={projects} handleClickProject={handleClickProject} />
          </div>
        </div>
      </Spinner>
    </>
  );
}
